<template>
  <modal :show.sync="show" :on-close="cancel">
    <div class="h-auto overflow-auto flex flex-col">
      <woot-modal-header
        :header-title="$t('CONTACT_PANEL.BLOCK_CONTACT_MODAL.TITLE')"
        :header-content="$t('CONTACT_PANEL.BLOCK_CONTACT_MODAL.MESSAGE')"
      />

      <div class="pt-4 px-8 w-full">
        <p class="text-slate-600 mt-2 text-sm dark:text-slate-300">
          {{ $t('CONTACT_PANEL.BLOCK_CONTACT_MODAL.SELECT_DURATION') }}
        </p>

        <div class="flex flex-row gap-2 mt-2">
          <input-radio-list :items="durationOptions" @change="onChange" />
        </div>
      </div>

      <div class="flex flex-row justify-end gap-2 py-4 px-6 w-full">
        <woot-button variant="clear" @click="cancel">
          {{ $t('CONTACT_PANEL.BLOCK_CONTACT_MODAL.NO') }}
        </woot-button>
        <woot-button @click="confirm">
          {{ $t('CONTACT_PANEL.BLOCK_CONTACT_MODAL.YES') }}
        </woot-button>
      </div>
    </div>
  </modal>
</template>
<script>
import Modal from 'dashboard/components/Modal.vue';
import InputRadioList from 'dashboard/components/ui/InputRadioList.vue';

export default {
  components: {
    Modal,
    InputRadioList,
  },
  data: () => ({
    show: false,
    resolvePromise: undefined,
    rejectPromise: undefined,
    durationOptions: [],
  }),
  mounted() {
    this.durationOptions = this.getDurationOptions();
    this.onChange(this.durationOptions[0]);
  },
  methods: {
    getDurationOptions() {
      const { options } = this.$t('MUTE_DURATIONS');
      return Object.values(options).map(duration => {
        return {
          id: duration.VALUE,
          name: duration.LABEL,
          checked: false,
        };
      });
    },

    showConfirmation() {
      this.onChange(this.durationOptions[0]);
      this.show = true;
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    confirm() {
      this.resolvePromise(true);
      this.show = false;
    },

    cancel() {
      this.resolvePromise(false);
      this.show = false;
    },

    onChange(item) {
      this.durationOptions.forEach(op => {
        op.checked = op.id === item.id;
      });

      this.$emit('change', item);
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-container .modal-footer {
  padding: var(--space-normal) var(--space-medium);
}
</style>
